<div class="deadline-label" *ngIf="text" [attr.aria-label]="ariaLabel">{{ text }}</div>
